export default "__VITE_ASSET__hSDkTF3C__"